<template>
  <!-- 奖品领取地址 -->
  <div class="claim-address flex items-center mb-4px">
    <el-cascader
      ref="districtCascade"
      class="district-cascade"
      :props="{...areaProps, multiple: false}"
      collapse-tags
      :show-all-levels="true"
      v-model="regionCodePath"
      placeholder="请选择地区"
      clearable
      @change="handleCascaderChange"
    />

    <el-input class="ml-1" v-model.trim="addressDetail" placeholder="输入详细地址" @change="handleAddressChange" />

    <div class="flex items-center ml-1">
      <el-button icon="el-icon-minus" circle plain size="small" v-if="removable" @click="dispatchAction('remove')" />
      <el-button icon="el-icon-plus" circle plain size="small" type="primary" v-if="addable" @click="dispatchAction('add')" />
    </div>
  </div>
</template>

<script>
import {regionCodeToPath} from '@/utils/region'
import RegionMixin from '@/mixins/region'
export default {
  name: "ClaimAddress",
  mixins: [RegionMixin],
  // model: {
  //   prop: 'value',
  //   event: 'change'
  // },
  props: {
    removable: {
      type: Boolean,
      default: false,
    },
    addable: {
      type: Boolean,
      default: true,
    },
    index: {
      type: Number,
      default: -1
    },
    value: {
      type: Object,
      default:() => ({addressDetail: '', regionCode: '', regionName: ''})
    },
  },
  data() {
    return {
      addressDetail: '', // 详细地址
      regionCodePath: [], // 地区编码
      regionName: '', // 省市区
    }
  },
  beforeMount() {
    // 获取商家默认门店地址
    let storeDefaultRegionCode = this.$store.getters.user?.regionCode || ''
    storeDefaultRegionCode = storeDefaultRegionCode ? storeDefaultRegionCode.split(',').map(item => item.padEnd(12, '0')) : []
    let storeDefaultAddress = this.$store.getters.user?.baseAddress || ''
    let storeDefaultRegionName = this.$store.getters.user?.regionName || ''
    storeDefaultRegionName = storeDefaultRegionName.replace(/,/g, '')

    let regionCodePath = this.value.regionCode ? this.value.regionCode.split(',') : storeDefaultRegionCode
    this.regionCodePath = regionCodePath
    this.addressDetail = this.value.addressDetail || storeDefaultAddress
    this.regionName = this.value.regionName || storeDefaultRegionName

    if (!this.value.regionCode) {
      this.$emit('change', {addressDetail: this.addressDetail, regionCode: regionCodePath.join(','), regionName: this.regionName})
    }
  },
  methods: {
    /** @param {Array<string>} data 编码列表 */
    handleCascaderChange(data) {
      this.$nextTick(() => this.handleAddressChange())
    },
    
    handleAddressChange() {
      this.regionName = this.$refs.districtCascade.presentText.replace(/\s+|\//g, '')
      let regionCode = this.regionCodePath.join(',')
      this.$emit('change', {addressDetail: this.addressDetail, regionCode, regionName: this.regionName})
    },

    dispatchAction(type) {
      this.$emit(type, this.index)
    },
  },
}
</script>